import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const NavBarContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap',
  paddingLeft: theme.spacing(10),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(3),
  },
}));

export const HeaderValue = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(0.2),
}));
